import Question from '../interfaces/question';
import { QuestionType } from '../interfaces/questionType';
import Survey from '../interfaces/survey';

interface collectChooseManyQuestionsProps {
  survey: Survey | undefined;
  questionIds: number[];
}

const collectChooseManyQuestions = ({
  survey,
  questionIds,
}: collectChooseManyQuestionsProps): Question[] => {
  if (!survey) return [];
  return survey.questions.filter(
    (question) => questionIds.includes(question.id) && question.type === QuestionType.CHOOSE_MANY,
  );
};

export { collectChooseManyQuestions };
